import { useState, useCallback } from 'react';
import axios from 'axios';
import appSettings from './AppSetting';

const defaultRequestTimeout = 60000;

export default function useAxios(baseUrl = '', headers = {}, apiPermGroupCode = 'OTHER') {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
      headers,
    },
    timeout: defaultRequestTimeout,
  });

  const makeRequest = useCallback(async (config) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance(config);
      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      setError(error);
      throw error;
    }
  }, []);


  const get = useCallback(
    async (url, params = {}, config = {}) => {
      return makeRequest({
        //  headers: {
        //     ...getHeaders(),
        //   },
        method: 'GET',
        url,
        params,
        ...config,
      });
    },
    [makeRequest]
  );

  const post = useCallback(
    async (url, data = {}, config = {}) => {
      return makeRequest({
        method: 'POST',
        url,
        data,
        ...config,
      });
    },
    [makeRequest]
  );

  const put = useCallback(
    async (url, data = {}, config = {}) => {
      return makeRequest({
        method: 'PUT',
        url,
        data,
        ...config,
      });
    },
    [makeRequest]
  );

  const del = useCallback(
    async (url, data = {}, config = {}) => {
      return makeRequest({
        method: 'DELETE',
        url,
        data,
        ...config,
      });
    },
    [makeRequest]
  );

  return { loading, error, get, post, put, del };
}